import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../GlobalContext';
import { useNavigate } from 'react-router-dom';

export default function PlayerList() {
  const navigate = useNavigate();
  const { alert, setLoading } = useContext(GlobalContext);

  const [players, setPlayers] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/player/all`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setPlayers(data);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    })()
      .catch((error) => alert({ type: 'danger', title: 'Error !', text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, setLoading]);

  const addPlayer = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/player/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('auth'),
        },
        body: JSON.stringify({ name, email }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        navigate(`/player-edit/${data}`);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="d-flex justify-content-center">
            {/* <button
              data-bs-toggle="modal"
              data-bs-target="#modal"
              className="btn btn-primary">
              Add Player
            </button> */}
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="card my-3">
              <div className="card-header flex-column align-items-center">
                <h2 className="page-title">Chapter Players</h2>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Gender</th>
                        {/* <th className="w-1">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {players.map((pl) => (
                        <tr key={pl._id}>
                          <td>{pl.name}</td>
                          <td>{pl.email}</td>
                          <td>{pl.phone}</td>
                          <td>{pl.gender}</td>
                          {/* <td className="w-1">
                            <Link
                              to={`/player-edit/${pl._id}`}
                              className="btn btn-primary">
                              Edit
                            </Link>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="modal"
        tabIndex="-1"
        className="modal modal-blur fade hide"
        aria-hidden="true">
        <div
          className="modal-dialog modal-dialog-centered"
          role="document">
          <form
            onSubmit={addPlayer}
            className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add new player</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setName('');
                  setEmail('');
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row mb-3 align-items-end">
                <div className="col">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="row mb-3 align-items-end">
                <div className="col">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="reset"
                className="btn me-auto"
                onClick={() => {
                  setName('');
                  setEmail('');
                }}
                data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                data-bs-dismiss="modal">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
